import { useQuery } from '@tanstack/react-query';
import BannerVisibilityService from '../services/BannerVisibilityService';
function useBannerVisibility({ visibilityUrl, enabled = true }) {
    return useQuery(['bannerVisibility', visibilityUrl], () => BannerVisibilityService.checkVisibility(visibilityUrl || ''), {
        enabled: enabled && Boolean(visibilityUrl),
        staleTime: 2 * 60 * 1000, // 2 minutes
        retry: 3,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        onError: (error) => {
            console.error('Failed to fetch banner visibility:', error);
        }
    });
}
export default useBannerVisibility;
